/* eslint-disable react/prop-types */
import React from 'react';
import { MultiPageNavigation } from 'Components/molecules/MultiPageNavigation';

export const getMultipageNavigation = ({
  content = [],
  currentUrl = null,
  showCurrentlyReadingText = false,
  showIndex = false,
  layout = 'expanded',
  stickyEnabled = false,
  extraProps = {},
}) => {
  if (Array.isArray(content) && content.length === 0) {
    return false;
  }

  return (
    <MultiPageNavigation
      allPagesLabel="See all pages"
      content={content}
      currentLabel="- currently reading"
      layout={layout}
      selectedUrl={currentUrl}
      showCurrentlyReadingText={showCurrentlyReadingText}
      showIndex={showIndex}
      showIndexNumber
      stickyActiveClass="polaris__multi-page-navigation--sticky"
      stickyEnabled={stickyEnabled}
      stickyTop=".polaris__subnav"
      {...extraProps}
    />
  );
};
